import BaseRepository from "./BaseRepository";

export default class UserRepository extends BaseRepository {

	constructor() {
		super();
		this.getOne = this.getOne.bind(this);
		this.create = this.create.bind(this);
		this.authorize = this.authorize.bind(this);
		this.edit = this.edit.bind(this);
		this.editPassword = this.editPassword.bind(this);
	}

	async getOne(user_id, filter) {
		return await this.get(`/user/${user_id}?filter${JSON.stringify(filter)}`);
	}
	
	async create(body) {
		return await this.post("/users", body);
	}

	async edit(user_id, body) {
		return await this.put(`/user/${user_id}`, body);
	}

	async authorize(email, password) {
		return await this.post(`/users/authorize`, { email, password });
	}

	async validateToken(token) {
		return await this.post(`/token/validate`, { token });
	}

	async editPassword(user_id, token, body) {
		return await this.post(`/user/${user_id}/password?token=${token}`, body);
	}
}



// WEBPACK FOOTER //
// src/api/lib/UserRepository.js